import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from 'src/contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactElement;
  requireProfileComplete?: boolean;
}

function ProtectedRoute({
  children,
  requireProfileComplete = true
}: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress size={64} />
      </Box>
    );
  }

  if (!user) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (requireProfileComplete && !user.is_profile_complete) {
    return <Navigate to="/auth/complete-profile" replace />;
  }

  return children;
}

export default ProtectedRoute;

